import axios from "src/lib/axios";

export const getAllReviewByAdmin = (dataSearch) =>
  axios.get("/reviews/find-all-by-admin", {
    params: {
      keyword: dataSearch.keyword,
      filter: dataSearch.filter,
    },
  });

export const getReviewDetail = (_id) => axios.get(`/review/find-one/${_id}`);
// export const rejectUpdateSeller = (info) =>
//   axios.patch("/sellers/reject", info);
// //approve seller page
export const updateStatusReview = (info) => {
  return axios.patch("/reviews/update-status", info);
};
export const updateStatusAllApproveReview = (info) => {
  return axios.patch("/reviews/update-multiple-status", info);
};

export const deleteAllSelectedReview = (info) => {
  return axios.delete("/reviews/delete-multiple-review", {
    data: {
      _id: info._id,
    },
  });
};

export const updateReplyReview = (info) => {
  return axios.patch("/reviews/update-reply", info);
};

export const createReview = (dataReview) => {
  return axios.post(`/reviews/admin-create`, dataReview, {
    headers: {
      "Content-Type": "multipart/form-data", // do not forget this
    },
  });
};

export const updateReview = (dataReview) => {
  return axios.patch(`/reviews/update`, dataReview, {
    headers: {
      "Content-Type": "multipart/form-data", // do not forget this
    },
  });
};
